import { render, staticRenderFns } from "./DataLocations.vue?vue&type=template&id=6b506113&scoped=true"
import script from "./DataLocations.vue?vue&type=script&lang=js"
export * from "./DataLocations.vue?vue&type=script&lang=js"
import style0 from "./DataLocations.vue?vue&type=style&index=0&id=6b506113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b506113",
  null
  
)

export default component.exports